<script>
  import options from './FilterConcept.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <article class="be-filter-concept">
    <div class="be-filter-concept__filters">
      <template v-for="filter, index in filters" :key="index">

          <button 
            class="be-filter-concept__filter" 
            :class="`${filter.open ? 'be-filter-concept__filter--open' : ''}`"
            v-on:click="(e) => openFilterDropdown(e, filter.name)"
            :aria-controls="`listbox_${filter.name}_${index}`" 
            :aria-expanded="filter?.open ?? false"
            :aria-haspopup="`listbox_${filter.name}_${index}`" 
            :aria-labelledby="`combo_${filter.name}_${index}_label`" 
            :id="`combo_${filter.name}_${index}`"
          >
            <div class="be-filter-concept__filter__content">
              <p 
                class="be-filter-concept__filter__content-label" 
                :id="`filter_${filter.name}_${index}`"
              >
                {{ filter.label }}  
              </p>
              <p class="be-filter-concept__filter__content-placeholder">
                {{ filter.placeholder }}
              </p>
              <span class="be-filter-concept__filter__content-chevron">
                <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6 9 6 6 6-6" stroke="#1E2B24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </div>
            <div 
              class="be-filter-concept__filter__dropdown" 
              :class="`${filter.open ? 'be-filter-concept__filter__dropdown--open' : ''}`"
              role="listbox" 
              :id="`listbox_${filter.name}_${index}`" 
              :aria-labelledby="`combo_${filter.name}_${index}_label`"
            >
              <ul>
                <template v-for="option, optionIndex in filter.options" :key="optionIndex">
                  <li 
                    tabindex="0"
                    class="be-filter-concept__filter__dropdown-item be-js--filter-concept__filter__dropdown-item" 
                    v-on:click="() => setFilter(option)"
                    v-on:keydown="(e) => handleDropdownItemKeyEvent(e, option, filter.name)">
                      <span>{{ option.name }}</span>
                      <span v-if="tagExists(option.value)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 44"><g clip-path="url(#a)"><path stroke="#1E2B24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.167 22 9.166 9.167 18.334-18.334"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h44v44H0z"/></clipPath></defs></svg>
                      </span>
                  </li>
                </template>
              </ul>
            </div>
          </button>
      </template>

    </div>

    <ul class="be-filter-concept__tags" aria-live="polite">
      <li v-for="tag, index in tags" :key="index">
        <button class="be-pill be-pill--action" v-on:click="removeTag(tag.value)">
          <span class="be-pill-name">{{ tag.name }}</span>
          <span class="be-pill-icon">
            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><g stroke-linecap="round" stroke-linejoin="round" stroke-width=".75" clip-path="url(#a)"><path stroke="#2554D1" d="M9 3 3 9"/><path stroke="#1E2B24" d="m3 3 6 6"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
          </span>
        </button>
      </li>
    </ul>
  </article>
</template>
